/**
 * P4U-A11Y 2026-10-22
 * Native <select> sorting for Horizon collection/search pages.
 * Reuses facets-form-component.updateFilters(); facets.js is NOT modified.
 */
class P4uSorting extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #onChange = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;

    const facetsForm = select.form?.closest('facets-form-component');
    if (!facetsForm || typeof facetsForm.updateFilters !== 'function') return;

    facetsForm.updateFilters();
  };
}

if (!customElements.get('p4u-sorting')) {
  customElements.define('p4u-sorting', P4uSorting);
}